//---- FancyBox, see application.scss for CSS
import { Fancybox } from "@fancyapps/ui/dist/index.js";

window.addEventListener("turbo:load", () => {
  Fancybox.bind("[data-fancybox]", {
    // Your custom options
  });  
});
document.addEventListener('turbo:before-cache', () => {
  Fancybox.destroy();
});
